/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const teamUpdateBodyDescriptionOneMax = 2000;

export const teamUpdateBodyExpectedVersionExclusiveMin = 0;
export const teamUpdateBodyExpectedVersionMax = 9007199254740991;

export const TeamUpdateBody = zod.object({
  name: zod.string().optional(),
  description: zod
    .union([zod.string().max(teamUpdateBodyDescriptionOneMax), zod.null()])
    .optional(),
  active: zod.boolean().optional(),
  expectedVersion: zod
    .int()
    .gt(teamUpdateBodyExpectedVersionExclusiveMin)
    .max(teamUpdateBodyExpectedVersionMax),
});

export type TeamUpdateBody = zod.input<typeof TeamUpdateBody>;
export type TeamUpdateBodyOutput = zod.output<typeof TeamUpdateBody>;
